@defer (when _reportCollections()) {
  <div #viewContainer class="report-view view-container" [class.print-preview]="wantsPrintPreview">
    <div class="report-view-title">
      <div class="row">
        <div class="col-md-12 text-center">
          <p></p>
          {{ report()?.title }}
          <p class="no-screen">{{ _masterReportConfig?.startAt | amDateFormat: 'DD MMMM YYYY' }}</p>
          <i class="fa fa-{{ report().icon }} pull-right"></i>
          <!--<i class="no-print pull-right fa fa-cog hvr-grow" title="Show page breaks" (click)="configToggle()"></i>-->
        </div>
      </div>
    </div>
    <div class="row">
      @for (rc of _reportConfigs; track rc; let i = $index) {
        <div class="col-sm-12" [class.pagebreakbefore]="i > 0">
          <div class="row gateway-title">
            <div class="col-sm-12">{{ rc.forGateways[0]?.title || rc.forCollections[0].title }}</div>
          </div>
          @if (report().blocks) {
            <div class="row">
              @for (item of report().blocks; track item; let i = $index) {
                <div class="col-md-12">
                  @if (item) {
                    <app-report-block-render [block]="item" [report]="report()" [reportConfig]="rc" (onLoaded)="hasLoaded(item)"></app-report-block-render>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
    @if (report().blocks) {
      <div class="row mt-1">
        <div class="col-md-12 text-center">
          Report created at
          <app-date [date]="createdAt"></app-date>
        </div>
      </div>
    }
  </div>
} @placeholder {
  <i class="mdi mdi-spin mdi-loading"></i>
}
